import { Component } from '@angular/core';
import { AdminComponent } from '../../../pages/admin/admin.component';

@Component({
    selector: 'app-rightmenu',
    templateUrl: './rightmenu.component.html'
})
export class RightmenuComponent{

  constructor(
    public app: AdminComponent
  ) { }

  }
